'use client';

import type { FundingModel } from '@bytel/leviator';
import {
    Box,
    BoxContent,
    DirectionEnum,
    FlexBox,
    FlexItem,
    IconName,
    RadioTile,
    Spacer,
    SpacerSize,
    Tag,
    TagVariant,
    Text,
    TextLevels,
    TrilogyColor,
} from '@bytel/trilogy-react';

import { FundingDetailsBox } from '@components/funding-details-box';
import { InlinePrice } from '@components/inline-price';

import { OdrInfos } from './odr-infos';

export interface FundingInstallmentItemProps {
    funding: FundingModel;
    isSelected: boolean;
    onSelect: () => void;
    hasOdr: boolean;
    odrRefund: number;
    phonePriceWithOdrDeducted: number;
}

export function FundingInstallmentItem({
    funding,
    isSelected,
    onSelect,
    hasOdr,
    odrRefund,
    phonePriceWithOdrDeducted,
}: Readonly<FundingInstallmentItemProps>) {
    const hasInterest = funding.interestAmount > 0;

    return (
        <FlexItem>
            <FlexBox direction={DirectionEnum.COLUMN} gap={1}>
                <RadioTile
                    id={funding.key}
                    horizontal
                    checked={isSelected}
                    onChange={onSelect}
                    description={
                        <FlexBox direction={DirectionEnum.COLUMN} gap={3}>
                            <InlinePrice
                                amount={funding.initialContributionWithOdr || funding.initialDeposit}
                                level={TextLevels.TWO}
                            />
                            <Text level={TextLevels.TWO} marginless>
                                +&nbsp;
                                <InlinePrice amount={funding.monthlyAmount} level={TextLevels.TWO} /> par mois pendant{' '}
                                {funding.installments ?? 0} mois {hasInterest ? 'avec frais' : null}
                            </Text>
                            {!hasInterest && (
                                <div>
                                    <Tag
                                        variant={TagVariant.INFO}
                                        iconName={IconName.SUN_EURO}
                                        small
                                        label='Crédit 0% sans frais'
                                    />
                                </div>
                            )}
                        </FlexBox>
                    }
                    name='fundingInstallment'
                />
                {isSelected && <FundingDetailsBox funding={funding} />}
                {hasOdr && isSelected && (
                    <>
                        <Box
                            backgroundColor={TrilogyColor.ACCENT_FADE}
                            highlighted={TrilogyColor.ACCENT}
                            padding='md'
                            radius='md'
                            shadowless
                        >
                            <BoxContent>
                                <OdrInfos odrRefund={odrRefund} phonePriceWithOdrDeducted={phonePriceWithOdrDeducted} />
                            </BoxContent>
                        </Box>
                        <Spacer size={SpacerSize.THREE} />
                    </>
                )}
            </FlexBox>
        </FlexItem>
    );
}
